import { Component, OnInit, Input } from '@angular/core';
import { NumberingListItem } from "../shared/numbering-list-item";
import { Syllabus } from "../shared/syllabus";
import { ObjectObservable } from "../../shared/base/object-observable";
import { Course } from "../../courses/shared/course";
import { MESSAGE_EDIT_SUCCESS, MESSAGE_COMMON_ERROR } from "../shared/message";
import { MatSnackBarConfig, MatSnackBar } from "@angular/material";
import { APPCONFIG } from "../../config";

@Component({
  selector: 'app-syllabus-curriculum-numbering-list-edit',
  templateUrl: './syllabus-curriculum-numbering-list-edit.component.html',
  styleUrls: ['./syllabus-curriculum-numbering-list-edit.component.scss']
})
export class SyllabusCurriculumNumberingListEditComponent implements OnInit {

  @Input() courseObservable:  ObjectObservable<Course>;;
  @Input() course: Course;
  AppConfig: any;

  constructor(
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

  async addNumberingListItem() {
    try {
      const item = new NumberingListItem();

      if(!this.course.syllabus.numberingList){
        this.course.syllabus.numberingList = [];
      }
      this.course.syllabus.numberingList.push(item);
      await this.courseObservable.update(this.course);
    } catch (e) {
      this.handleError(e);
    }
  }


  async onSubmit(value: Syllabus) {
    try {
      this.course.syllabus = value;
      await this.courseObservable.update(this.course);
      this.handleSuccess();
    } catch (e) {
      this.handleError(e);
    }
  }

  async removeNumberingListItem(i: number) {
    try {
      this.course.syllabus.numberingList.splice(i, 1);
      await this.courseObservable.update(this.course);
    }catch (e) {
      this.handleError(e);
    }
  }

  private handleSuccess() {
    this.openSnackBar(MESSAGE_EDIT_SUCCESS);
  }

  private handleError(error: any) {
    this.openSnackBar(MESSAGE_COMMON_ERROR);
  }

  private openSnackBar(message) {
    const config = new MatSnackBarConfig();
    config.duration = 3000;
    this.snackBar.open(message, null, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-numbering-list-edit/syllabus-curriculum-numbering-list-edit.component.ts